export default __webpack_public_path__ + "static/media/AlexBrush-Regular.b50947ef.ttf";